import React from 'react';

export interface TopBarSkeletonSSRProps {
  /** Background color for the top bar container */
  containerBgColor?: string;
}

/**
 * SSR-safe TopBar skeleton component.
 * Uses pure inline styles for SSR compatibility (no Chakra UI).
 * Renders placeholder content for the announcement/promo bar.
 */
export const TopBarSkeletonSSR = ({
  containerBgColor = '#c8102e',
}: TopBarSkeletonSSRProps) => {
  return (
    <aside
      data-testid="top-bar-skeleton-ssr"
      role="complementary"
      aria-label="Store announcements"
      style={{
        backgroundColor: containerBgColor,
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '1.5rem',
        paddingLeft: '2.672rem',
        paddingRight: '2.672rem',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          marginBottom: '2.672rem',
          paddingTop: '0.668rem',
          paddingBottom: '0.668rem',
          maxWidth: '1440px',
        }}
      >
        {/* Left placeholder - announcement text area */}
        <span
          aria-hidden="true"
          style={{
            height: '24px',
            width: '250px',
            backgroundColor: 'rgba(255, 255, 255, 0.3)',
            borderRadius: '2px',
            display: 'block',
          }}
        />

        {/* Right placeholders - utility links area */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '1.336rem',
          }}
        >
          <span
            aria-hidden="true"
            style={{
              height: '24px',
              width: '120px',
              backgroundColor: 'rgba(255, 255, 255, 0.3)',
              borderRadius: '6px',
              display: 'block',
            }}
          />
          {/* Desktop only placeholder */}
          <span
            aria-hidden="true"
            style={{
              height: '24px',
              width: '100px',
              backgroundColor: 'rgba(255, 255, 255, 0.3)',
              borderRadius: '6px',
              display: 'block',
            }}
          />
        </div>
      </div>
    </aside>
  );
};

TopBarSkeletonSSR.displayName = 'TopBarSkeletonSSR';
